import { ChangeDetectionStrategy, Component, output } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { IconComponent } from '@ui';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, TranslocoDirective],
  selector: 'app-template-header',
  template: `
    <ng-container *transloco="let t">
      <div
        class="flex flex-col gap-y-4 bg-gradient-to-r from-[#1990ff] to-[#0066c5] p-4 pb-9 mt-1 text-white rounded-md"
      >
        <div class="flex justify-between items-center">
          <ui-icon
            class="h-[25px]"
            [class]="'text-white text-[125px] leading-none'"
            icon="icons:volta-white"
          />
          <button (click)="emitClosePopover()">
            <ui-icon icon="close"></ui-icon>
          </button>
        </div>
        <div class="flex flex-col gap-y-2 mb-4">
          <h1 class="font-extralight text-[28px] text-white">
            {{ t('HELP_CENTER.TITLE') }}
          </h1>
          <p class="text-base">
            {{ t('HELP_CENTER.SUBTITLE') }}
          </p>
        </div>
      </div>
    </ng-container>
  `,
})
export class NameComponent {
  sendClose = output<void>();

  emitClosePopover(): void {
    this.sendClose.emit();
  }
}
